import http from "../http-common";

class KitchenFastQuoteDataService {
  getAll() {
    return http.get("/kitchenfastquote");
  }

  // not ready yet
  getAllMultipleConditions(data) {
    return http.post("/kitchenfastquote/findbymultipleconditions",data);
  }

  getkitchenfastquoteBy(userid, sortfield,sorttype) {
    return http.get(`/kitchenfastquote/search/?userid=${userid}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getCondition(condition) {
    return http.get(`/kitchenfastquote/search/?type=${condition}`);
  }

  getMaxId() {
    return http.get(`/kitchenfastquote/vals/maxid`);
  }

  get(id) {
    return http.get(`/kitchenfastquote/get/${id}`);
  }

  create(data) {
    return http.post("/kitchenfastquote", data);
  }

  update(id, data) {
    return http.put(`/kitchenfastquote/update/${id}`, data);
  }

  delete(id) {
    return http.delete(`/kitchenfastquote/${id}`);
  }

  deleteAll() {
    return http.delete(`/kitchenfastquote`);
  }

  findById(id) {
    return http.get(`/kitchenfastquote/get/${id}`);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new KitchenFastQuoteDataService();

// for req.query:
// use params in Postman, 
//path without /:"param" in the backend and 
//path with /?"parameter"="valueparameter" in the front end